import React from 'react';
import {Box, Container, Typography} from '@mui/material';
import {FormattedMessage} from "react-intl";

export default function WelcomePage() {

    return (
        <Container maxWidth="sm" sx={{mt: 4}}>
            <Box textAlign="center" py={5}>
                <Typography variant="h3" component="h1" gutterBottom>
                    <FormattedMessage id="Welcome!" defaultMessage="Welcome!"/>
                </Typography>
                <Typography variant="body1" gutterBottom>
                    <FormattedMessage
                        id="We are happy to have you in our application. Explore the features and have fun!"
                        defaultMessage="We are happy to have you in our application. Explore the features and have fun!"/>
                </Typography>
            </Box>
        </Container>
    );
}
